class AddGuestsController {

    constructor(basket, addGuestService, propertyService, guestnameService, itemService, loadingService) {
        this.basket = basket;
        this.addGuestService = addGuestService;
        this.propertyService = propertyService;
        this.guestnameService = guestnameService;
        this.itemService = itemService;
        this.loadingService = loadingService;
    }

    $onInit () {
        this.item = this.itemService.getItem();

        this.titles = this.addGuestService.buildTitlesList();
        this.existingGuests = this.addGuestService.filterGuestsByGender(this.basket.contents.guest_details);

        this.guests = this.addGuestService.setInitialGuests(this.addGuestService.getGuests());
    }

    canLoadStaff () {
        return this.propertyService.get('loadStaff');
    }

    canDisplayStaff () {
        return !!(this.canLoadStaff()
            && !this.loadingService.isLoading()
            && this.staff
            && this.staff.length);
    }

    displayMinMaxGuests () {
        let string = `This ${this.item.type_display} can be booked for ${this.numberOfGuests()}.`;

        if (this.item.gender) {
            const gender = (this.item.gender === 'M') ? 'male' : 'female';
            string += ` It is only available to ${gender} guests.`;
        }

        return string;
    }

    numberOfGuests () {
        if (!this.propertyService.get('hasIntegration') && this.item.quantity > this.item.maximum_guests) {
            this.item.quantity = this.item.maximum_guests;
            this.itemService.setItem(this.item);
        }

        if (parseInt(this.item.minimum_guests) !== parseInt(this.item.quantity)) {
            return `${this.item.minimum_guests} to ${this.item.quantity} guests`;
        }

        if (this.item.quantity > 1) {
            return `${this.item.quantity} guests`;
        }

        return `${this.item.quantity} guest`;
    }

    notEnoughGuests () {
        this.error = null;
        if (this.item.quantity && parseInt(this.item.minimum_guests) > parseInt(this.item.quantity)) {
            this.error = '<em>Sorry, there is currently no availability for the selected time.</em>';
            return true;
        }

        return false;
    }

    sumGuest (guest) {
        const custom = guest.item_children.reduce((acc, curr) => {
            let price = 0;
            if (curr && curr.price) {
                price = curr.price.price;
            }

            return acc + price;
        }, 0);

        return parseInt(this.item.price) + parseInt(custom);
    }

    showRemoveButton () {
        return this.guests.length > this.item.minimum_guests;
    }
}

AddGuestsController.$inject = ['basket', 'addGuestService', 'propertyService', 'guestnameService', 'itemService', 'loadingService'];

export default AddGuestsController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/controllers/guests.add.controller.js